<div class="modal__content">
    <div class="loading-popup-header">
        <span>Loading...</span>
    </div>
    <div class="loading-popup-text">
        <div class="loader__container">
	        <div class="loader"></div>
	    </div>
    </div>
</div>
